import { Component, Input, OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { MatDialog, MatDialogConfig, MatDialogRef, MatSnackBar } from '@angular/material';
import { EditDescComponent } from '../edit-desc/edit-desc.component';
import { IConditionalSection } from '../../shared/models/condition-section.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';

@Component({
  selector: 'app-business-description',
  templateUrl: './business-description.component.html',
  styleUrls: ['./business-description.component.scss']
})
export class BusinessDescriptionComponent implements OnInit, IConditionalSection {
  @Input() business: Business;
  editModeSet = false;

  constructor(private _editDescDialog: MatDialog,
              private _toggleService: EditToggleService,
              public snackBar: MatSnackBar) { }

  ngOnInit() {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
  }

  get hasContent(): boolean {
    return this.business && !!this.business.description;
  }

  openEditDescDialog() {
    const DATA = {business: this.business};
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = DATA;

    dialogConfig.width = '100%';

    const DIALOG_REF = this._editDescDialog.open(EditDescComponent, dialogConfig);
    this._handleModalClose(DIALOG_REF);
  }

  /**
   * listens for dialog close event. Opens snackbar if necessary
   * @param {MatDialogRef<any>} dialogRef
   * @private
   */
  _handleModalClose ( dialogRef: MatDialogRef<any>) {
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';

    dialogRef.afterClosed().subscribe((success) => {
      if (success === null) { return; }
      if (success) {
        this.snackBar.open('Business Description', 'Updated', {
          duration: 3000
        });
      } else {
        this.snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }

}
